import { PanelContainer } from '../../../types';
import { PanelContextProvider, useMakePanelContext } from '../PanelContext';

export const EmptyPanelWrapper: PanelContainer = (props) => {
  const { contextValue } = useMakePanelContext(props);

  return (
    <PanelContextProvider value={contextValue}>
      {props.children}
    </PanelContextProvider>
  );
};
